import { createShellPreferencesStore } from '@jarvis/platform-ui';

export const useShellPreferencesStore = createShellPreferencesStore({
  storageKey: 'webopsui:shell-prefs'
});
